import * as React from "react";
import Layout from "../components/layout";
import Seo from "../components/seo";
import HeroSection from "../components/Home/HeroSection";
import AboutUs from "../components/Home/AboutUs";
import OurServices from "../components/Home/OurServices";
import "animate.css";

import { ParallaxProvider } from "react-scroll-parallax";

const IndexPage = () => (
  <ParallaxProvider>
    <Layout>
      <Seo title="Home" />
      <HeroSection />
      <AboutUs />
      <OurServices />
    </Layout>
  </ParallaxProvider>
);

export default IndexPage;
